import { EDimensionType } from '@src/common/constant/enum';

export interface IPresetInfo {
  id: number;
  isDefault: number;
  name: string;
  dimensions: IDimensionInfo[];
  // fixed means no need to update through api when dimensions changed
  dimensionFixed: boolean;
}

export interface IDimensionInfo {
  dimensionName: string;
  displayName: string;
  dimensionType: EDimensionType;
}

export enum ETableSize {
  AUTO,
  MEDIUM,
  LARGE,
}

export enum ESupportMappingMode {
  NOT_SUPPORT,
  SUPPORT,
}

export const eventDimensionNames = ['all_event_name', 'conviva_event_name', 'custom_event_name'];
export const tagDimensionNames = ['merged_event_tag_key', 'merged_event_tag_value', 'mapped_event'];

export const exploreLockedDimensionNames = [
  ...eventDimensionNames,
  'merged_event_tag_key',
  'merged_event_tag_value',
  'mapped_event',
];

export const eventDimensions = [
  {
    dimensionName: 'all_event_name',
    displayName: 'All Event',
    dimensionType: EDimensionType.MAPPED,
  },
  {
    dimensionName: 'conviva_event_name',
    displayName: 'Conviva Event',
    dimensionType: EDimensionType.MAPPED,
  },
  {
    dimensionName: 'custom_event_name',
    displayName: 'Custom Event',
    dimensionType: EDimensionType.MAPPED,
  },
];

export const tagDimensions = [
  {
    dimensionName: 'merged_event_tag_key',
    displayName: 'Event Tag Key',
    dimensionType: EDimensionType.MAPPED,
  },
  {
    dimensionName: 'merged_event_tag_value',
    displayName: 'Event Tag Value',
    dimensionType: EDimensionType.MAPPED,
  },
  {
    dimensionName: 'mapped_event',
    displayName: 'Mapped Event',
    dimensionType: EDimensionType.ORIGINAL,
  },
];

export const lockedDimensions = [...eventDimensions, ...tagDimensions];
